import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/home";
import BlogPage from "./pages/blog";
import LoginForm from "./pages/login";
import BlogForm from "./pages/dashboard";
import BlogView from "./components/BlogView";
import PrivateRoute from "./components/PrivateRoute";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/admin" element={<LoginForm />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:id" element={<BlogView />} />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <BlogForm />
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
